"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFedopsLogger = void 0;
var fedops_logger_1 = require("@wix/fedops-logger");
var constants_1 = require("./constants");
var createFedopsLogger = function () { return (0, fedops_logger_1.create)(constants_1.FEDOPS_LOGGER_ID); };
exports.createFedopsLogger = createFedopsLogger;
//# sourceMappingURL=createFedopsLogger.js.map